import { DocumentTypeWithoutInvoice } from "utilities/documentUtils";
import { routes } from "utilities/routing/generatedRoutes";
import { CapitalizeFirstLetter } from "utilities/typeUtils";


export const getEsignRoute = (documentType: DocumentTypeWithoutInvoice, itemId: number) => {
  const esignRoute: keyof typeof routes = `${documentType}_ESign`;
  return routes[esignRoute](itemId).absolute;
}

export const getLegacyRoute = (documentType: DocumentTypeWithoutInvoice) => {
  const documentNewRoute: keyof typeof routes = `${documentType}_New`;
  return routes[documentNewRoute]().absolute;
}

export const getLegacyRouteForShow = (documentType: DocumentTypeWithoutInvoice, showId: number) => {
  const firstLetterCapitalizedDocType = documentType.charAt(0).toUpperCase() + documentType.slice(1) as CapitalizeFirstLetter<DocumentTypeWithoutInvoice>;
  const documentForShowNewRoute: keyof typeof routes = `show_New${firstLetterCapitalizedDocType}`;

  return routes[documentForShowNewRoute](showId).absolute;
}